/** Сегментный переключатель (M1: режим, сортировка). Цвет текста задан явно. */
export function Segmented<T extends string>({
  label,
  value,
  options,
  onChange,
  testPrefix,
}: {
  label: string;
  value: T;
  options: readonly { id: T; label: string }[];
  onChange: (id: T) => void;
  testPrefix: string;
}) {
  return (
    <div role="group" aria-label={label} className="inline-flex gap-[3px] rounded-sm border border-bd p-[3px]">
      {options.map((o) => {
        const on = o.id === value;
        return (
          <button
            key={o.id}
            type="button"
            aria-pressed={on}
            data-testid={`${testPrefix}-${o.id}`}
            onClick={() => onChange(o.id)}
            className={`rounded-[3px] border-0 px-2.5 py-1 font-mono text-[11.5px] leading-none ${on ? "bg-accsoft text-acc" : "bg-transparent text-mut hover:text-ink"}`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
